import { useContext, useState } from "react";

import {
  Box,
  Stack,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  IconButton,
  TableContainer,
} from "@mui/material";

import AddBoxIcon from "@mui/icons-material/AddBox";
import "./accordionsvillage.scss";

import { AuthContext } from "../../Context/AuthContext";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import VillageForm from "../../Components/Village/VillageForm";
import VillageAction from "../../Components/Village/VillageAction";
import useWithDimension from "../../Hooks/useWithDimension";

import { useGetVillageByCommune } from "../../Hooks/useGetVillageByCommune";


export default function AccordionsVillage({ communeData, districtMunicipalitiesId }) {
  const { t } = useContext(AuthContext);
  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();

  const { loading, refetch, tableData } = useGetVillageByCommune({
    communeSangkatId: communeData?._id,
  });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  return (
    <div className="page-container">
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("no")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width="20%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("thead_code")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width="20%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("thead_name")}(KH)
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width="20%"
                  sx={{ paddingY: "3px !important" }}
                >
                  {t("thead_name")}(ENG)
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width="16%"
                  sx={{ paddingY: "3px !important" }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <IconButton onClick={() => handleOpen()}>
                      <AddBoxIcon sx={{ color: "#223D97" }} />
                    </IconButton>

                    {open && (
                      <VillageForm
                        open={open}
                        handleClose={handleClose}
                        setRefetch={refetch}
                        dialogTitle="Create"
                        communeSangkatId={communeData?._id}
                        districtMunicipalitiesId={districtMunicipalitiesId}
                      />
                    )}
                  </Stack>
                </TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={6}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={6} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + 1}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.village_code}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.village_name_kh}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.village_name_en}
                            </TableCell>
                            <TableCell className="body-cell-end" align="right">
                              <VillageAction
                                editData={row}
                                setRefetch={refetch}
                                districtMunicipalitiesId={districtMunicipalitiesId}
                                communeSangkatId={communeData?._id}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
